//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'

export default {
  name: 'TaskActionButton',
  // Отключаем автоматическое "размазывание" атрибутов на корневой элемент,
  // чтобы они попали именно в q-btn через v-bind="$attrs"
  inheritAttrs: false,
  props: {
    actionType: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      // loadingLocal: false
      // loadingActivity: null - Не реактивное!
    }
  },
  computed: {
    ...mapGetters({
      taskLoading: 'getTaskLoading'
    }),
    matchTaskLoading: function () {
      return this.taskLoading.active && this.taskLoading.actionType === this.actionType
    },
    loadingTotal: function () {
      return this.$attrs.loading || this.matchTaskLoading // || this.loadingLocal
    }
  },
  created: function () {
    const btnCmp = this
    this.loadingActivity = {
      actionType: btnCmp.actionType,
      actionName: null,
      startLoading: function (actionName) {
        this.actionName = actionName

        btnCmp.$store.dispatch('setTaskLoading', {
          active: true,
          actionType: this.actionType,
          actionName: this.actionName
        })
      },
      stopLoading: function () {
        btnCmp.$store.dispatch('setTaskLoading', null)
      }
    }
  },
  methods: {
    getLoadingActivity: function () {
      return this.loadingActivity
    },
    onClick: function (event, navigateFn) {
      this.$emit('click', event, navigateFn, this.getLoadingActivity())
    }
  }
}

